import { render, staticRenderFns } from "./HistoricoTitulo.vue?vue&type=template&id=73aca149"
import script from "./HistoricoTitulo.vue?vue&type=script&lang=js"
export * from "./HistoricoTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73aca149')) {
      api.createRecord('73aca149', component.options)
    } else {
      api.reload('73aca149', component.options)
    }
    module.hot.accept("./HistoricoTitulo.vue?vue&type=template&id=73aca149", function () {
      api.rerender('73aca149', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HistoricoTitulo.vue"
export default component.exports